export default __webpack_public_path__ + "static/loader-0fed6fc68129c3b35a8fa7224b8d369e.png";